import { render, staticRenderFns } from "./DocumentEditorDialog.component.vue?vue&type=template&id=1ff12c09&scoped=true"
import script from "./DocumentEditorDialog.component.vue?vue&type=script&lang=js"
export * from "./DocumentEditorDialog.component.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditorDialog.component.vue?vue&type=style&index=0&id=1ff12c09&prod&scoped=true&lang=css"
import style1 from "./DocumentEditorDialog.component.vue?vue&type=style&index=1&id=1ff12c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff12c09",
  null
  
)

export default component.exports